var _style, _defs, _path, _path2, _path3, _g, _defs2, _path4, _path5, _path6, _g2, _defs3, _path7, _g3, _defs4, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _g4, _g5, _defs5, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _defs6, _defs7, _defs8, _defs9, _defs10, _defs11, _defs12, _defs13, _defs14, _defs15, _defs16, _g6, _defs17, _path26, _path27, _path28, _g7, _defs18, _path29, _path30, _path31, _path32, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1080 1080",
    style: {
      enableBackground: "new 0 0 1080 1080"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{enable-background:new    ;}\n\t.st1{clip-path:url(#SVGID_00000004507221069777869360000006052316776897749386_);enable-background:new    ;}\n\t.st2{fill:#2E3F42;}\n\t.st3{fill:#2D3D40;}\n\t.st4{fill:#2B3B3E;}\n\t.st5{fill:#314347;}\n\t.st6{clip-path:url(#SVGID_00000127723699122614595780000011263052526702299824_);enable-background:new    ;}\n\t.st7{clip-path:url(#SVGID_00000121264889132529386730000005693663433583247748_);enable-background:new    ;}\n\t.st8{fill:#243134;}\n\t.st9{fill:#243133;}\n\t.st10{clip-path:url(#SVGID_00000019675967879127970680000011759507808552500656_);enable-background:new    ;}\n\t.st11{fill:#263336;}\n\t.st12{fill:#273538;}\n\t.st13{fill:#29373A;}\n\t.st14{fill:#2A393C;}\n\t.st15{fill:#3D5357;}\n\t.st16{clip-path:url(#SVGID_00000151525064571544239350000010466152546685557661_);enable-background:new    ;}\n\t.st17{display:none;}\n\t.st18{display:inline;}\n\t.st19{clip-path:url(#SVGID_00000155138190847765503120000003577795669354773928_);}\n\t.st20{clip-path:url(#SVGID_00000089534708573267785590000010113765534910789005_);fill:#3E545E;}\n\t.st21{clip-path:url(#SVGID_00000089534708573267785590000010113765534910789005_);fill:#2A3940;}\n\t.st22{clip-path:url(#SVGID_00000057847368458226672600000006728636883618905015_);fill:#2A3940;}\n\t.st23{clip-path:url(#SVGID_00000130622789803520936120000016002075507153991057_);fill:#4B6268;}\n\t.st24{clip-path:url(#SVGID_00000130622789803520936120000016002075507153991057_);fill:#3F5259;}\n\t.st25{clip-path:url(#SVGID_00000111879032753049140110000000671618357759512997_);fill:#3F5259;}\n\t.st26{clip-path:url(#SVGID_00000068648974939388778140000005257499393830622370_);fill:#34444A;}\n\t.st27{clip-path:url(#SVGID_00000103254160722922502110000000187735867382906520_);fill:#8B9DA3;}\n\t.st28{clip-path:url(#SVGID_00000103254160722922502110000000187735867382906520_);fill:#678086;}\n\t.st29{clip-path:url(#SVGID_00000067926295015843845360000004126295881154832783_);fill:#2D3F45;}\n\t.st30{clip-path:url(#SVGID_00000067926295015843845360000004126295881154832783_);fill:#1E292E;}\n\t.st31{clip-path:url(#SVGID_00000133518238916897753730000006556937958336552873_);fill:#485F65;}\n\t.st32{clip-path:url(#SVGID_00000150811231412915554750000004141128129074527399_);fill:#485F65;}\n\t.st33{clip-path:url(#SVGID_00000044152820505532237700000010306724352615597999_);fill:#5B777D;}\n\t.st34{clip-path:url(#SVGID_00000044152820505532237700000010306724352615597999_);fill:#50696E;}\n\t.st35{fill:#364852;}\n\t.st36{fill:#202A30;}\n\t.st37{fill:#2C3B42;}\n\t.st38{clip-path:url(#SVGID_00000021822793902773704350000017952674590605209482_);enable-background:new    ;}\n\t.st39{fill:#323F45;}\n\t.st40{fill:#303D43;}\n\t.st41{fill:#2F3C40;}\n\t.st42{fill:#263034;}\n\t.st43{clip-path:url(#SVGID_00000069373674872530260260000012208349495421231274_);enable-background:new    ;}\n\t.st44{fill:#2D3A3E;}\n\t.st45{fill:#303D42;}\n\t.st46{fill:#41545B;}\n\t.st47{fill:#283338;}\n\t.st48{fill:#495B5F;}\n\t.st49{fill:#354244;}\n\t.st50{fill:#5A7175;}\n")), /*#__PURE__*/React.createElement("g", {
    id: "Icon_awesome-user-alt"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    className: "st0",
    d: "M648.78,570.88l34.19,18.6c-12.63-6.87-27.61-9.77-43.68-7.51l-34.19-18.6 C621.17,561.11,636.15,564.01,648.78,570.88z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000001654659891222043880000002140573998412635054_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000001654659891222043880000002140573998412635054_)",
      enableBackground: "new"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M639.29,581.97l-34.19-18.6c9.94-1.4,19.46-0.82,28.27,1.44l34.19,18.6 C658.75,581.15,649.23,580.57,639.29,581.97"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M667.55,583.41l-34.19-18.6c4.51,1.16,8.83,2.76,12.93,4.77l34.19,18.6 C676.38,586.18,672.06,584.57,667.55,583.41"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M680.48,588.19l-34.19-18.6c0.84,0.41,1.67,0.84,2.49,1.29l34.19,18.6 C682.15,589.03,681.32,588.6,680.48,588.19"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "604.08,586.92 569.89,568.32 605.1,563.37 639.29,581.97  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000074415039774745139080000009003524402369240209_",
    className: "st0",
    d: "M510.93,600.01l-34.19-18.6 c14.77,5.28,30.66,6.72,46.56,4.48c15.9-2.23,31.8-8.15,46.6-17.58l34.19,18.6c-14.79,9.43-30.7,15.34-46.6,17.58 C541.58,606.73,525.69,605.29,510.93,600.01z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000075841886262842561600000005910747483000290216_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000074415039774745139080000009003524402369240209_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000075841886262842561600000005910747483000290216_)",
      enableBackground: "new"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M510.93,600.01l-34.19-18.6c2.61,0.93,5.26,1.75,7.93,2.44l34.19,18.6 C516.19,601.76,513.54,600.94,510.93,600.01"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M518.86,602.45l-34.19-18.6c12.45,3.23,25.54,3.88,38.62,2.04c11-1.55,22.01-4.85,32.65-9.87l34.19,18.6 c-10.64,5.02-21.65,8.33-32.65,9.87C544.4,606.33,531.31,605.68,518.86,602.45"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M590.13,594.62l-34.19-18.6c4.73-2.23,9.39-4.8,13.95-7.7l34.19,18.6 C599.53,589.82,594.87,592.39,590.13,594.62"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "475.72,604.96 441.53,586.36 476.74,581.41 510.93,600.01  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000116950980775612839440000006870787944148410805_",
    className: "st0",
    d: "M407.99,741.72l-34.19-18.6 c-8.57-4.66-14.25-14.2-14.24-25.97l34.19,18.6C393.74,727.52,399.42,737.06,407.99,741.72z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000171693414334411225820000016571035375739877031_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000116950980775612839440000006870787944148410805_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000171693414334411225820000016571035375739877031_)",
      enableBackground: "new"
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M407.99,741.72l-34.19-18.6c-8.57-4.66-14.25-14.2-14.24-25.97l34.19,18.6 C393.74,727.52,399.42,737.06,407.99,741.72"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "393.76,715.75 359.57,697.15 359.59,686.12 393.78,704.72  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000152970852658081322080000005929337252453337772_",
    className: "st0",
    d: "M393.78,704.72l-34.19-18.6 c0.1-48.76,36.79-93.42,81.94-99.76l34.19,18.6C430.57,611.29,393.88,655.95,393.78,704.72z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000173883324934752567360000008511430960591316663_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000152970852658081322080000005929337252453337772_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000173883324934752567360000008511430960591316663_)",
      enableBackground: "new"
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M393.78,704.72l-34.19-18.6c0.02-12,2.27-23.76,6.3-34.75l34.19,18.6 C396.04,680.96,393.8,692.71,393.78,704.72"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M400.08,669.97l-34.19-18.6c1.74-4.74,3.82-9.34,6.2-13.76l34.19,18.6 C403.9,660.62,401.82,665.22,400.08,669.97"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M406.28,656.2l-34.19-18.6c2.01-3.74,4.24-7.35,6.66-10.81l34.19,18.6 C410.52,648.85,408.29,652.46,406.28,656.2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M412.94,645.4l-34.19-18.6c2.29-3.26,4.74-6.38,7.36-9.34l34.19,18.6 C417.69,639.02,415.23,642.14,412.94,645.4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M420.3,636.05l-34.19-18.6c2.63-2.98,5.42-5.79,8.34-8.43l34.19,18.6 C425.72,630.26,422.93,633.08,420.3,636.05"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M428.64,627.63l-34.19-18.6c3.14-2.83,6.44-5.44,9.88-7.82l34.19,18.6 C435.09,622.18,431.78,624.8,428.64,627.63"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M438.53,619.8l-34.19-18.6c4.23-2.92,8.67-5.49,13.28-7.66l34.19,18.6 C447.2,614.31,442.76,616.88,438.53,619.8"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M451.81,612.14l-34.19-18.6c7.57-3.55,15.6-6.02,23.91-7.19l34.19,18.6 C467.4,606.12,459.38,608.59,451.81,612.14"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M639.29,581.97c45.17-6.35,81.7,28.03,81.61,76.77l-0.02,11.03c-0.04,18.28-13.79,35.03-30.73,37.42 l-265.78,37.35c-16.93,2.37-30.64-10.52-30.61-28.79l0.02-11.03c0.1-48.76,36.79-93.42,81.94-99.76l35.21-4.95 c14.77,5.28,30.66,6.72,46.56,4.48c15.9-2.23,31.8-8.15,46.6-17.58L639.29,581.97z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M557.55,571.4c-50.81,7.12-91.91-31.54-91.82-86.38c0.1-54.84,41.37-105.09,92.18-112.23 c50.82-7.14,91.92,31.53,91.82,86.38C649.63,514.01,608.36,564.26,557.55,571.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000037654167257287077110000000745084611113861527_",
    className: "st0",
    d: "M508.41,562.94l-34.19-18.6 c-25.71-13.99-42.74-42.6-42.68-77.92c0.1-54.84,41.37-105.09,92.18-112.23c18.09-2.54,34.94,0.72,49.15,8.45l34.19,18.6 c-14.21-7.73-31.06-10.99-49.15-8.45c-50.81,7.14-92.08,57.39-92.18,112.23C465.67,520.35,482.7,548.96,508.41,562.94z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000167364604813234171920000002313150844591157391_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000037654167257287077110000000745084611113861527_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000167364604813234171920000002313150844591157391_)",
      enableBackground: "new"
    }
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M508.41,562.94l-34.19-18.6c-25.71-13.99-42.74-42.6-42.68-77.92c0.03-13.5,2.55-26.72,7.09-39.09 l34.19,18.6c-4.54,12.37-7.06,25.59-7.09,39.09C465.67,520.35,482.7,548.96,508.41,562.94"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M472.82,445.93l-34.19-18.6c1.96-5.33,4.29-10.51,6.97-15.48l34.19,18.6 C477.12,435.42,474.78,440.6,472.82,445.93"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M479.79,430.45l-34.19-18.6c2.26-4.21,4.77-8.27,7.49-12.15l34.19,18.6 C484.56,422.18,482.05,426.24,479.79,430.45"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M487.28,418.29l-34.19-18.6c2.57-3.67,5.34-7.18,8.28-10.51l34.19,18.6 C492.62,411.12,489.86,414.63,487.28,418.29"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M495.57,407.78l-34.19-18.6c2.96-3.35,6.09-6.52,9.39-9.48l34.19,18.6 C501.66,401.27,498.52,404.44,495.57,407.78"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M504.95,398.3l-34.19-18.6c3.53-3.18,7.25-6.12,11.12-8.8l34.19,18.6 C512.2,392.18,508.49,395.12,504.95,398.3"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M516.08,389.5l-34.19-18.6c4.76-3.29,9.75-6.18,14.94-8.62l34.19,18.6 C525.83,383.32,520.83,386.21,516.08,389.5"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M531.02,380.88l-34.19-18.6c8.51-4,17.54-6.77,26.9-8.09c11.18-1.57,21.9-0.92,31.8,1.62l34.19,18.6 c-9.91-2.55-20.62-3.2-31.8-1.62C548.56,374.11,539.53,376.88,531.02,380.88"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M589.72,374.42l-34.19-18.6c5.07,1.31,9.94,3.11,14.54,5.37l34.19,18.6 C599.66,377.53,594.79,375.72,589.72,374.42"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M604.26,379.79l-34.19-18.6c0.95,0.46,1.88,0.95,2.8,1.45l34.19,18.6 C606.14,380.74,605.21,380.25,604.26,379.79"
  }))))))), /*#__PURE__*/React.createElement("g", {
    className: "st17"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st18"
  }, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000052067757401926205810000011362295902424996243_",
    x: 540,
    y: -68.47,
    width: 1080,
    height: 1080
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000092447611234557754660000000906473010918498435_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000052067757401926205810000011362295902424996243_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000092447611234557754660000000906473010918498435_)"
    }
  }, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000181052231395261349950000000156632071687540102_",
    x: 540,
    y: -68.47,
    width: 1080,
    height: 1080
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000110429697149880237560000016797664138860844932_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000181052231395261349950000000156632071687540102_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000110429697149880237560000016797664138860844932_)",
      fill: "#3E545E"
    },
    d: "M1100.01,592.84 l205.3,141.3c-62.42,22.68-133.86,34.02-205.31,34.02s-142.89-11.34-205.32-34.02L1100.01,592.84z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000110429697149880237560000016797664138860844932_)",
      fill: "#2A3940"
    },
    d: "M1305.31,734.13 v115.62c-62.42,22.68-133.86,34.02-205.31,34.02s-142.89-11.34-205.32-34.02V734.13c62.43,22.68,133.88,34.02,205.32,34.02 S1242.89,756.81,1305.31,734.13"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000092447611234557754660000000906473010918498435_)"
    }
  }, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000079445182265734324070000002714146543804638395_",
    d: "M1100.01,768.15c-71.44,0-142.89-11.34-205.32-34.02 v115.62c62.43,22.68,133.88,34.02,205.32,34.02c71.44,0,142.88-11.34,205.31-34.02V734.13 C1242.89,756.81,1171.45,768.15,1100.01,768.15"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000071560628284194479150000004373912772767758754_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000079445182265734324070000002714146543804638395_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000071560628284194479150000004373912772767758754_)",
      fill: "#2A3940"
    },
    d: "M1305.31,734.13 v115.62c-14.74,5.35-29.98,10.08-45.6,14.17V748.3C1275.34,744.21,1290.58,739.49,1305.31,734.13"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000071560628284194479150000004373912772767758754_)",
      fill: "#2A3940"
    },
    d: "M1259.71,748.3 v115.62c-20.96,5.49-42.6,9.84-64.66,13.05V761.35C1217.11,758.14,1238.76,753.79,1259.71,748.3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000071560628284194479150000004373912772767758754_)",
      fill: "#2A3940"
    },
    d: "M1195.06,761.35 v115.62c-13.22,1.93-26.59,3.44-40.05,4.55V765.9C1168.47,764.79,1181.83,763.27,1195.06,761.35"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000071560628284194479150000004373912772767758754_)",
      fill: "#2A3940"
    },
    d: "M1155.01,765.9 v115.62c-11.1,0.91-22.26,1.55-33.45,1.91V767.81C1132.75,767.45,1143.91,766.81,1155.01,765.9"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000071560628284194479150000004373912772767758754_)",
      fill: "#2A3940"
    },
    d: "M1121.57,767.81 v115.62c-7.18,0.23-14.37,0.34-21.56,0.34c-2.88,0-5.77-0.02-8.65-0.05V768.1c2.88,0.04,5.77,0.06,8.65,0.06 C1107.2,768.15,1114.39,768.04,1121.57,767.81"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000071560628284194479150000004373912772767758754_)",
      fill: "#2A3940"
    },
    d: "M1091.36,768.1 v115.62c-9.51-0.12-19.02-0.45-28.5-0.97V767.13C1072.34,767.65,1081.84,767.98,1091.36,768.1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000071560628284194479150000004373912772767758754_)",
      fill: "#2A3940"
    },
    d: "M1062.86,767.13 v115.62c-9.27-0.51-18.52-1.22-27.72-2.12V765.01C1044.34,765.91,1053.58,766.62,1062.86,767.13"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000071560628284194479150000004373912772767758754_)",
      fill: "#2A3940"
    },
    d: "M1035.14,765.01 v115.62c-9.24-0.9-18.43-2-27.56-3.29V761.73C1016.71,763.02,1025.9,764.11,1035.14,765.01"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000071560628284194479150000004373912772767758754_)",
      fill: "#2A3940"
    },
    d: "M1007.58,761.73 v115.62c-9.44-1.34-18.81-2.88-28.09-4.63V757.1C988.77,758.85,998.14,760.39,1007.58,761.73"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000071560628284194479150000004373912772767758754_)",
      fill: "#2A3940"
    },
    d: "M979.49,757.1v115.62 c-9.95-1.88-19.79-3.99-29.5-6.35V750.75C959.7,753.1,969.54,755.22,979.49,757.1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000071560628284194479150000004373912772767758754_)",
      fill: "#2A3940"
    },
    d: "M949.99,750.75 v115.62c-10.99-2.67-21.81-5.64-32.42-8.92V741.82C928.18,745.1,939,748.08,949.99,750.75"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000071560628284194479150000004373912772767758754_)",
      fill: "#2A3940"
    },
    d: "M917.58,741.82 v115.62c-7.75-2.4-15.39-4.96-22.9-7.69V734.13C902.19,736.86,909.83,739.42,917.58,741.82"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000092447611234557754660000000906473010918498435_)"
    }
  }, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000030453675676357940560000007421005140438706567_",
    x: 540,
    y: -68.47,
    width: 1080,
    height: 1080
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000044877535693500568790000014580815762868139401_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000030453675676357940560000007421005140438706567_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000044877535693500568790000014580815762868139401_)",
      fill: "#4B6268"
    },
    d: "M1100.01,302.41 c192.9,0,349.28,78.2,349.28,174.65c0,57.87-50.35,107.28-143.97,141.29l-205.3-141.29V302.41z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000044877535693500568790000014580815762868139401_)",
      fill: "#3F5259"
    },
    d: "M1449.29,477.06 v115.62c0,57.87-50.35,107.28-143.97,141.29V618.36C1398.94,584.34,1449.29,534.93,1449.29,477.06"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000092447611234557754660000000906473010918498435_)"
    }
  }, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000145759958493120150840000011770683272130582195_",
    d: "M1305.31,618.36v115.62 c93.63-34.02,143.97-83.43,143.97-141.29V477.06C1449.29,534.93,1398.94,584.34,1305.31,618.36"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000083055150814420989060000013705897769956917646_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000145759958493120150840000011770683272130582195_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000083055150814420989060000013705897769956917646_)",
      fill: "#3F5259"
    },
    d: "M1449.29,477.06 v115.62c0,0.76-0.01,1.53-0.03,2.29V479.35C1449.28,478.59,1449.29,477.83,1449.29,477.06"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000083055150814420989060000013705897769956917646_)",
      fill: "#3F5259"
    },
    d: "M1449.26,479.35 v115.62c-0.13,5.51-0.71,10.95-1.76,16.3V495.66C1448.55,490.31,1449.13,484.87,1449.26,479.35"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000083055150814420989060000013705897769956917646_)",
      fill: "#3F5259"
    },
    d: "M1447.51,495.66 v115.62c-0.97,5.01-2.35,9.95-4.12,14.82V510.48C1445.16,505.61,1446.53,500.67,1447.51,495.66"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000083055150814420989060000013705897769956917646_)",
      fill: "#3F5259"
    },
    d: "M1443.39,510.48 V626.1c-1.72,4.72-3.8,9.37-6.26,13.93V524.41C1439.59,519.84,1441.67,515.2,1443.39,510.48"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000083055150814420989060000013705897769956917646_)",
      fill: "#3F5259"
    },
    d: "M1437.13,524.41 v115.62c-2.47,4.61-5.32,9.13-8.53,13.57V537.98C1431.81,533.54,1434.66,529.02,1437.13,524.41"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000083055150814420989060000013705897769956917646_)",
      fill: "#3F5259"
    },
    d: "M1428.6,537.98 v115.62c-3.37,4.65-7.14,9.21-11.31,13.67V551.66C1421.46,547.2,1425.23,542.64,1428.6,537.98"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000083055150814420989060000013705897769956917646_)",
      fill: "#3F5259"
    },
    d: "M1417.29,551.66 v115.62c-4.62,4.95-9.74,9.77-15.33,14.47V566.13C1407.55,561.43,1412.67,556.6,1417.29,551.66"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000083055150814420989060000013705897769956917646_)",
      fill: "#3F5259"
    },
    d: "M1401.96,566.13 v115.62c-6.83,5.73-14.38,11.27-22.64,16.61V582.74C1387.58,577.4,1395.13,571.86,1401.96,566.13"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000083055150814420989060000013705897769956917646_)",
      fill: "#3F5259"
    },
    d: "M1379.32,582.74 v115.62c-14.15,9.15-30.38,17.69-48.61,25.56V608.3C1348.94,600.43,1365.17,591.88,1379.32,582.74"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000083055150814420989060000013705897769956917646_)",
      fill: "#3F5259"
    },
    d: "M1330.71,608.3 v115.62c-8.08,3.49-16.54,6.84-25.4,10.06V618.36C1314.17,615.14,1322.64,611.79,1330.71,608.3"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000092447611234557754660000000906473010918498435_)"
    }
  }, _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000026874423177180268550000004124788822277423031_",
    x: 540,
    y: -68.47,
    width: 1080,
    height: 1080
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000090998427153961379260000011224962226537925040_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000026874423177180268550000004124788822277423031_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000090998427153961379260000011224962226537925040_)",
      fill: "#34444A"
    },
    points: " 1305.31,618.36 1305.31,733.98 1100.01,592.69 1100.01,477.06  "
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000092447611234557754660000000906473010918498435_)"
    }
  }, _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000120546723066045465500000016458339397420956857_",
    x: 540,
    y: -68.47,
    width: 1080,
    height: 1080
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000058562644563061160820000012426554123915058312_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000120546723066045465500000016458339397420956857_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000058562644563061160820000012426554123915058312_)",
      fill: "#8B9DA3"
    },
    d: "M1100.01,73.13 v174.65L992.06,81.69C1028.76,75.73,1061.42,73.13,1100.01,73.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000058562644563061160820000012426554123915058312_)",
      fill: "#678086"
    },
    points: " 1100.01,247.78 1100.01,363.41 992.06,197.31 992.06,81.69  "
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000092447611234557754660000000906473010918498435_)"
    }
  }, _defs13 || (_defs13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000132804305503625538340000011438522517292707004_",
    x: 540,
    y: -68.47,
    width: 1080,
    height: 1080
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000008108086709765204280000012715061956834290848_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000132804305503625538340000011438522517292707004_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000008108086709765204280000012715061956834290848_)",
      fill: "#2D3F45"
    },
    d: "M992.06,196.9 l107.95,166.1L767.8,309.03C803.58,253.98,881.97,214.78,992.06,196.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000008108086709765204280000012715061956834290848_)",
      fill: "#1E292E"
    },
    points: " 1100.01,362.99 1100.01,478.61 767.8,424.65 767.8,309.03  "
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000092447611234557754660000000906473010918498435_)"
    }
  }, _defs14 || (_defs14 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000023981437760488312980000009678465780585905075_",
    x: 540,
    y: -68.47,
    width: 1080,
    height: 1080
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000006688248744805081520000013432351183278874514_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000023981437760488312980000009678465780585905075_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000006688248744805081520000013432351183278874514_)",
      fill: "#485F65"
    },
    d: "M749.95,595.49 V479.87c0,54.45,51.35,105.81,144.73,139.73v115.62C801.3,701.3,749.95,649.94,749.95,595.49"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000092447611234557754660000000906473010918498435_)"
    }
  }, _defs15 || (_defs15 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000148638681253040211320000009498276962272012194_",
    d: "M749.95,595.49c0,54.45,51.35,105.8,144.73,139.73 V619.6c-93.38-33.93-144.73-85.29-144.73-139.73V595.49z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000064321881599832288470000004434732990843192255_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000148638681253040211320000009498276962272012194_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000064321881599832288470000004434732990843192255_)",
      fill: "#485F65"
    },
    d: "M894.68,619.6v115.62 c-5.38-1.96-10.62-3.97-15.73-6.04V613.57C884.06,615.63,889.3,617.65,894.68,619.6"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000064321881599832288470000004434732990843192255_)",
      fill: "#485F65"
    },
    d: "M878.96,613.57 v115.62c-83.4-33.82-129.01-82.39-129.01-133.7V479.87C749.95,531.18,795.55,579.74,878.96,613.57"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000092447611234557754660000000906473010918498435_)"
    }
  }, _defs16 || (_defs16 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000165221991127264063160000012178655669783844779_",
    x: 540,
    y: -68.47,
    width: 1080,
    height: 1080
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000085949364985804810930000000490786375894644917_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000165221991127264063160000012178655669783844779_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000085949364985804810930000000490786375894644917_)",
      fill: "#5B777D"
    },
    d: "M767.8,424.33 l332.21,53.98L894.68,619.6C769.84,574.24,720.12,497.73,767.8,424.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000085949364985804810930000000490786375894644917_)",
      fill: "#50696E"
    },
    points: " 1100.01,478.31 1100.01,593.93 894.68,735.22 894.68,619.6  "
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st35",
    points: "795.52,410.25 795.47,439.07 688.63,454.09 688.69,425.26  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st36",
    points: "688.63,454.09 677.24,447.89 677.29,419.06 688.69,425.26  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st37",
    points: "688.69,425.26 677.29,419.06 784.13,404.05 795.52,410.25  "
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Icon_metro-pencil"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs17 || (_defs17 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000091008250899715550050000004152043262785466300_",
    className: "st0",
    d: "M737.34,262.87l11.4,6.2 c-2.23-1.22-4.89-1.73-7.74-1.33l-11.4-6.2C732.46,261.15,735.11,261.66,737.34,262.87z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000049215808593361526030000015700554525051061179_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000091008250899715550050000004152043262785466300_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000049215808593361526030000015700554525051061179_)",
      enableBackground: "new"
    }
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M741,267.75l-11.4-6.2c1.77-0.25,3.46-0.15,5.02,0.26l11.4,6.2C744.45,267.6,742.76,267.5,741,267.75"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M746.02,268l-11.4-6.2c0.8,0.21,1.56,0.49,2.28,0.84l11.4,6.2C747.58,268.49,746.81,268.21,746.02,268"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M748.3,268.85l-11.4-6.2c0.15,0.07,0.29,0.15,0.44,0.23l11.4,6.2 C748.6,268.99,748.45,268.92,748.3,268.85"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st42",
    points: "727.62,304.94 716.22,298.74 711.26,294.08 722.66,300.28  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs18 || (_defs18 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000138561325024303161630000013079951541760659353_",
    className: "st0",
    d: "M732.39,272.07l-11.4-6.2 c2.49-2.36,5.5-3.88,8.6-4.32l11.4,6.2C737.9,268.18,734.88,269.7,732.39,272.07z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000124868682295347812870000014704353306543653789_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000138561325024303161630000013079951541760659353_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000124868682295347812870000014704353306543653789_)",
      enableBackground: "new"
    }
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M732.39,272.07l-11.4-6.2c0.12-0.11,0.24-0.23,0.36-0.33l11.4,6.2 C732.63,271.84,732.51,271.95,732.39,272.07"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M732.76,271.73l-11.4-6.2c0.56-0.5,1.14-0.96,1.74-1.38l11.4,6.2 C733.9,270.77,733.31,271.23,732.76,271.73"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M734.5,270.35l-11.4-6.2c0.75-0.52,1.52-0.97,2.32-1.34l11.4,6.2 C736.02,269.39,735.25,269.83,734.5,270.35"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M736.82,269.01l-11.4-6.2c1.34-0.63,2.75-1.06,4.18-1.26l11.4,6.2 C739.57,267.95,738.17,268.38,736.82,269.01"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st45",
    points: "687.21,354.14 675.81,347.94 716.22,298.74 727.62,304.94  "
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M741,267.75c8-1.12,14.43,4.93,14.42,13.51c-0.01,3.36-1.03,6.77-2.9,9.73l-5.77,7.02l-20.12-18.92 l5.77-7.03C734.88,269.7,737.9,268.18,741,267.75z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st42",
    points: "746.74,298.01 735.35,291.81 715.23,272.89 726.62,279.09  "
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st45",
    points: "726.62,279.09 715.23,272.89 721,265.87 732.39,272.07  "
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st47",
    points: "663.09,378.16 651.69,371.96 657.5,343.16 668.9,349.36  "
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st45",
    points: "668.9,349.36 657.5,343.16 710.89,278.16 722.29,284.36  "
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M668.9,349.36l53.39-65l20.13,18.93l-53.4,65.01l-25.93,9.86L668.9,349.36z M727.62,304.94l-4.96-4.65 l-40.41,49.19l4.96,4.66L727.62,304.94"
  })))))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Icon_material-person-add"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st48",
    points: "600.86,270.21 589.46,264.01 625.14,258.99 636.54,265.19  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st49",
    points: "576.95,337.74 565.55,331.54 565.63,293.03 577.02,299.23  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st49",
    points: "577.07,273.55 565.67,267.35 565.75,228.84 577.14,235.04  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st48",
    points: "577.14,235.04 565.75,228.84 589.54,225.5 600.93,231.7  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st50",
    points: "600.93,231.7 600.86,270.21 636.54,265.19 636.49,290.87 600.81,295.89 600.74,334.39  576.95,337.74 577.02,299.23 541.34,304.24 541.39,278.57 577.07,273.55 577.14,235.04  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st49",
    points: "541.34,304.24 529.95,298.04 530,272.37 541.39,278.57  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st48",
    points: "541.39,278.57 530,272.37 565.67,267.35 577.07,273.55  "
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.5b8d20aa829187dfdf5dd783378bb15a.svg";
export { ForwardRef as ReactComponent };